// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-ef10425f] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.native-datetime-picker[data-v-ef10425f] {
  display: flex;
  flex-direction: column;
}
.native-datetime-picker .native-datetime-picker--input[data-v-ef10425f] {
  width: 100%;
  flex: 0 0 auto;
  padding-right: 4px;
}
[data-theme-light] .native-datetime-picker--input[data-v-ef10425f],
[data-themes*=light] .native-datetime-picker--input[data-v-ef10425f] {
  color-scheme: light;
}
[data-theme-dark] .native-datetime-picker--input[data-v-ef10425f],
[data-themes*=dark] .native-datetime-picker--input[data-v-ef10425f] {
  color-scheme: dark;
}
@media (prefers-color-scheme: light) {
[data-theme-default] .native-datetime-picker--input[data-v-ef10425f],
  [data-themes*=default] .native-datetime-picker--input[data-v-ef10425f] {
    color-scheme: light;
}
}
@media (prefers-color-scheme: dark) {
[data-theme-default] .native-datetime-picker--input[data-v-ef10425f],
  [data-themes*=default] .native-datetime-picker--input[data-v-ef10425f] {
    color-scheme: dark;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDateTimePickerNative-BfZfqRvD.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;AACA;;IAEI,mBAAmB;AACvB;AACA;AACA;AACA;;IAEI,kBAAkB;AACtB;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-ef10425f] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.native-datetime-picker[data-v-ef10425f] {\n  display: flex;\n  flex-direction: column;\n}\n.native-datetime-picker .native-datetime-picker--input[data-v-ef10425f] {\n  width: 100%;\n  flex: 0 0 auto;\n  padding-right: 4px;\n}\n[data-theme-light] .native-datetime-picker--input[data-v-ef10425f],\n[data-themes*=light] .native-datetime-picker--input[data-v-ef10425f] {\n  color-scheme: light;\n}\n[data-theme-dark] .native-datetime-picker--input[data-v-ef10425f],\n[data-themes*=dark] .native-datetime-picker--input[data-v-ef10425f] {\n  color-scheme: dark;\n}\n@media (prefers-color-scheme: light) {\n[data-theme-default] .native-datetime-picker--input[data-v-ef10425f],\n  [data-themes*=default] .native-datetime-picker--input[data-v-ef10425f] {\n    color-scheme: light;\n}\n}\n@media (prefers-color-scheme: dark) {\n[data-theme-default] .native-datetime-picker--input[data-v-ef10425f],\n  [data-themes*=default] .native-datetime-picker--input[data-v-ef10425f] {\n    color-scheme: dark;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
